import React from 'react';
import { CoreProps } from '../types';
import TextareaAutosize from 'react-textarea-autosize';
// Design system
import { Font } from 'src/design-system/text/font';
// styles
import styles from './textarea.module.scss';

interface TextareaProps {
    id: string;
    name: string;
    placeholder?: string;
    value: string;
    onchange?: any;
    onblur?: any;
    label?: string;
    require?: boolean;
}

export const Textarea = (props: TextareaProps & CoreProps) => {
    const { id, name, placeholder, value, onchange, onblur, label, require, className = undefined, composeClassName = undefined } = props;
    const clss = [composeClassName, className].filter(Boolean).join(' ');

    return (
        <div className={styles.textarea}>
            {label && (
                <Font.OxaniumRegular as="span" mobile="12" desktop="12" className={styles.label}>
                    <label htmlFor={id}>
                        {label}
                        {require ? ' *' : ''}
                    </label>
                </Font.OxaniumRegular>
            )}
            <TextareaAutosize
                minRows={1}
                maxRows={10}
                id={id}
                name={name}
                placeholder={placeholder ? placeholder : ''}
                value={value}
                className={clss}
                onChange={onchange}
                onBlur={onblur}
            />
        </div>
    );
};
